import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VBreadcrumbs,{attrs:{"items":_vm.breadcrumbs,"divider":">"}}),_c('h1',{staticClass:"headline pb-4 mx-lg-auto"},[_vm._v("Settings")]),_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"disable-pagination":"","hide-default-footer":""},on:{"click:row":_vm.editItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }